module.exports = __webpack_public_path__ + "static/media/pokeball.e3ad9c5e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pokeball.png
 ** module id = 179
 ** module chunks = 0
 **/